module.exports = {
	"id": "MY",
	"name": "Malaysia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.013818,
			"11": 0.032242,
			"12": 0.013818,
			"13": null,
			"14": 0.004606,
			"15": 0.009212,
			"16": null,
			"17": null,
			"18": 0.009212,
			"19": 0.009212,
			"20": 0.013818,
			"21": 0.009212,
			"22": 0.02303,
			"23": 0.009212,
			"24": 0.004606,
			"25": 0.009212,
			"26": 0.013818,
			"27": 0.013818,
			"28": 0.009212,
			"29": 0.013818,
			"30": 0.02303,
			"31": 0.096726,
			"32": 0.018424,
			"33": 0.078302,
			"34": 0.02303,
			"35": 0.018424,
			"36": 0.027636,
			"37": 0.018424,
			"38": 0.04606,
			"39": 0.055272,
			"40": 0.027636,
			"41": 0.032242,
			"42": 0.032242,
			"43": 0.110544,
			"44": 0.105938,
			"45": 0.124362,
			"46": 0.147392,
			"47": 0.119756,
			"48": 0.119756,
			"49": 1.764098,
			"50": 0.202664,
			"51": 0.709324,
			"52": 0.792232,
			"53": 21.528444,
			"54": 4.670484,
			"55": 0.193452,
			"56": 0.059878,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.018424,
			"4": 0.009212,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.004606,
			"11": 0.013818,
			"12": 0.013818,
			"13": 0.009212,
			"14": 0.004606,
			"15": 0.004606,
			"16": 0.013818,
			"17": 0.004606,
			"18": null,
			"19": 0.004606,
			"20": 0.009212,
			"21": null,
			"22": 0.009212,
			"23": 0.004606,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.013818,
			"28": 0.004606,
			"29": 0.018424,
			"30": 0.013818,
			"31": 0.018424,
			"32": 0.013818,
			"33": 0.013818,
			"34": 0.013818,
			"35": 0.02303,
			"36": 0.02303,
			"37": 0.02303,
			"38": 0.04606,
			"39": 0.041454,
			"40": 0.036848,
			"41": 0.036848,
			"42": 0.032242,
			"43": 0.142786,
			"44": 0.059878,
			"45": 0.101332,
			"46": 0.073696,
			"47": 0.409934,
			"48": 0.41454,
			"49": 3.836798,
			"50": 0.32242,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.018424
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.02303,
			"35": 0.004606,
			"36": 0.009212,
			"37": 0.128968,
			"38": 0.013818,
			"39": 0.004606,
			"40": 0.18424,
			"41": 0.027636,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.009212
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.018424,
			"6": 0.018424,
			"7": 0.032242,
			"8": 0.133574,
			"9": 0.128968,
			"10": 0.52969,
			"3.1": null,
			"3.2": null,
			"5.1": 0.041454,
			"6.1": 0.027636,
			"7.1": 0.009212,
			"9.1": 0.446782
		},
		"ios_saf": {
			"8": 0,
			"10": 4.19908140466,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.113160384992,
			"8.1-8.4": 0.209059016341,
			"9.0-9.2": 0.0997345766028,
			"9.3": 1.5215916174
		},
		"android": {
			"3": 0,
			"4": 0.108473157623,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0135591447028,
			"4.1": 0.391278175711,
			"4.2-4.3": 0.978195439276,
			"4.4": 2.24306993798,
			"4.4.3-4.4.4": 2.2624401447
		},
		"ie": {
			"6": 0.00466515963303,
			"7": 0.0186606385321,
			"8": 0.335891493578,
			"9": 0.228592822018,
			"10": 0.163280587156,
			"11": 1.79142129908,
			"5.5": null
		},
		"op_mob": {
			"0": 0.248811500104,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00691143055845
		},
		"edge": {
			"12": 0.032242,
			"13": 0.179634,
			"14": 0.336238
		},
		"ie_mob": {
			"10": 0.0414729295775,
			"11": 0.168854070423
		},
		"bb": {
			"7": 0.02292025,
			"10": null
		},
		"samsung": {
			"0": 3.354446
		},
		"and_uc": {
			"0": 7.771313
		},
		"op_mini": {
			"0": 3.35219406934
		},
		"and_chr": {
			"0": 29.479221
		},
		"and_ff": {
			"0": 0.037751
		}
	},
	"total": 98.74080225
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MY.json
 ** module id = 602
 ** module chunks = 0
 **/